const local = {
    apiUrl: 'https://adminpanel.easyreferencing.com/api/public/api/',
};
module.exports = local

